import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import {
  STANDARD_SCRIPT_BLOCKS,
  StandardScriptBlock,
  StandardScriptBlockShape,
} from "@/app/types/messages-content/StandardScriptBlock";

const STANDARD_BLOCK_KEYS: Record<StandardScriptBlock, TKey> = {
  [StandardScriptBlock.OPENING]: TKey.MESSAGES_CONTENT_SCRIPT_BLOCK_OPENING,
  [StandardScriptBlock.QUESTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_BLOCK_QUESTIONS,
  [StandardScriptBlock.OBJECTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_BLOCK_OBJECTIONS,
  [StandardScriptBlock.NEXT_STEP]: TKey.MESSAGES_CONTENT_SCRIPT_BLOCK_NEXT_STEP,
};

const BLOCK_PLACEHOLDER_KEYS: Partial<Record<StandardScriptBlock, TKey>> = {
  [StandardScriptBlock.OPENING]: TKey.MESSAGES_CONTENT_SCRIPT_OPENING_PLACEHOLDER,
  [StandardScriptBlock.NEXT_STEP]: TKey.MESSAGES_CONTENT_SCRIPT_NEXT_STEP_PLACEHOLDER,
};

const BLOCK_ADD_KEYS: Partial<Record<StandardScriptBlock, TKey>> = {
  [StandardScriptBlock.QUESTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_QUESTION_ADD,
  [StandardScriptBlock.OBJECTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_OBJECTION_ADD,
};

const BLOCK_ITEM_PLACEHOLDER_KEYS: Partial<Record<StandardScriptBlock, TKey>> = {
  [StandardScriptBlock.QUESTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_QUESTION_PLACEHOLDER,
  [StandardScriptBlock.OBJECTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_OBJECTION_PLACEHOLDER,
};

const BLOCK_RESPONSE_PLACEHOLDER_KEYS: Partial<Record<StandardScriptBlock, TKey>> = {
  [StandardScriptBlock.OBJECTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_RESPONSE_PLACEHOLDER,
};

const BLOCK_SUGGESTION_KEYS: Partial<Record<StandardScriptBlock, TKey>> = {
  [StandardScriptBlock.QUESTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_PAINS_TITLE,
};

const BLOCK_CALLS_KEYS: Partial<Record<StandardScriptBlock, TKey>> = {
  [StandardScriptBlock.OBJECTIONS]: TKey.MESSAGES_CONTENT_SCRIPT_OBJECTIONS_TITLE,
};

export function blockShape(type: string): StandardScriptBlockShape | undefined {
  return STANDARD_SCRIPT_BLOCKS.find((shape) => shape.type === type);
}

export function blockTitle(t: TFn, type: string): string {
  const key = STANDARD_BLOCK_KEYS[type as StandardScriptBlock];
  return key ? t(key) : type;
}

export function blockPlaceholder(t: TFn, type: string): string {
  return translateBlockKey(t, BLOCK_PLACEHOLDER_KEYS, type);
}

export function blockAddLabel(t: TFn, type: string): string {
  return translateBlockKey(t, BLOCK_ADD_KEYS, type);
}

export function blockItemPlaceholder(t: TFn, type: string): string {
  return translateBlockKey(t, BLOCK_ITEM_PLACEHOLDER_KEYS, type);
}

export function blockResponsePlaceholder(t: TFn, type: string): string {
  return translateBlockKey(t, BLOCK_RESPONSE_PLACEHOLDER_KEYS, type);
}

export function blockSuggestionTitle(t: TFn, type: string): string {
  return translateBlockKey(t, BLOCK_SUGGESTION_KEYS, type);
}

export function blockCallsTitle(t: TFn, type: string): string {
  return translateBlockKey(t, BLOCK_CALLS_KEYS, type);
}

function translateBlockKey(
  t: TFn,
  keys: Partial<Record<StandardScriptBlock, TKey>>,
  type: string,
): string {
  const key = keys[type as StandardScriptBlock];
  return key ? t(key) : "";
}

const PLACEHOLDER_ROW_COUNTS: Partial<Record<StandardScriptBlock, number>> = {
  [StandardScriptBlock.QUESTIONS]: 5,
  [StandardScriptBlock.OBJECTIONS]: 3,
};

export function blockPlaceholderRowCount(type: string): number {
  return PLACEHOLDER_ROW_COUNTS[type as StandardScriptBlock] ?? 2;
}
